import React from "react";
import { Link } from "react-router-dom";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

export default function LinkWithLanguage({ to, className, content, href, isLink = false }) {
  const { languagePath } = useCurrentLanguage();
  return (
    <Link to={isLink ? to : languagePath + to} className={className} href={href} target={isLink ? "_blank" : ""}>
      {content}
    </Link>
  );
}
